module.exports = __webpack_public_path__ + "img/icon-warning-snow-yellow.781f61a1.svg";